import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'

export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation (
      $invoiceId: ID!
    ) {
        cancelInvoice(
            invoiceId: $invoiceId,
      )
    }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const cancelInvoice = useCallback((obj) => {
    mutation({ variables: obj }).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.cancelInvoice : null, error, validationErrors, cancelInvoice }
}
